export default "__VITE_ASSET__DCHAH3H9__"